import { Level2Wrapper } from '../common/Level2Wrapper';
import { ImageList } from '../common/ImageList';
import { useExteriorSectionData } from '../../hooks/useExteriorSection';

export const ExteriorDamage = () => {
  const { images: fitFinishFrameImages } = useExteriorSectionData('fit_finish_frame');
  const { images: exteriorImages } = useExteriorSectionData('exterior');
  const { images: tiresImages } = useExteriorSectionData('tires');

  const damagedImages = [...exteriorImages, ...tiresImages, ...fitFinishFrameImages].filter(
    (img: any) => img.is_damaged
  );

  if (damagedImages.length === 0) {
    return null;
  }

  return (
    <Level2Wrapper flex="1 1 100%" label="Damage">
      <ImageList label="Damage Pictures" images={damagedImages} />
    </Level2Wrapper>
  );
};
